export default {
  we_unite_the__:
    "Мы объединяем КОМЬЮНИТИ в ЕДИНУЮ ЖИВУЮ СЕТЬ и направляем вас по пути, который лучше всего ОТВЕЧАЕТ вашим целям.".toUpperCase(),
  learn_more__: "БОЛЬШЕ О Vision".toUpperCase(),
  we_are_putting__:
    "Мы помогаем всему комьюнити стать устойчивым к любым блокировкам и удалению кем-либо.".toUpperCase(),
  this_is_the__: "мы - каталог нового поколения. качество погружения, которое вы никогда не видели.".toUpperCase(),
  featured_vlogs: "важное".toUpperCase(),
  featuring_real__:
    "Объективные рейтинги, никакого блата, глубокое погружение в детали, эксклюзивные анонсы, ежедневная поддержка и постоянные обновления.".toUpperCase(),
};
